package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.SavedClient
import br.com.heyagenda.domain.repository.ClientRepository

class SaveClientUseCase(
    private val repository: ClientRepository
) {
    suspend operator fun invoke(client: SavedClient): Result<Unit> {
        return repository.saveClient(client)
    }
}
